import { initialState } from "./../initialState";
import * as GanttActions from "./ganttActions";

export const ganttReducer = (state = initialState.gantt, action) => {
    switch (action.type) {
        case GanttActions.GANTT_SELECTED_LABOURER:
            return Object.assign({}, state, {
                selectedLabourer: action.selectedLabourer,
            });

        case GanttActions.CHANGE_GANTT_WIDTH:
            return Object.assign({}, state, {
                width: action.width,
            });

        default:
            return state;
    }
};
